import types from './types';

const getScheduleForWeekRequest = (start, end) => ({
  type: types.GET_SCHEDULE_FOR_WEEK_REQUEST,
  start,
  end
});

const getScheduleForWeekSuccess = (start, schedule) => ({
  type: types.GET_SCHEDULE_FOR_WEEK_SUCCESS,
  start,
  schedule
});

const getScheduleForWeekFailure = () => ({
  type: types.GET_SCHEDULE_FOR_WEEK_FAILURE
});

const setCurrentWeekScheduleId = scheduleId => ({
  type: types.SET_CURRENT_WEEK_SCHEDULE_ID,
  scheduleId
});

const createNewScheduleRequest = (start, end) => ({
  type: types.CREATE_NEW_SCHEDULE_REQUEST,
  start,
  end
});

const createNewScheduleSuccess = (start, schedule) => ({
  type: types.CREATE_NEW_SCHEDULE_SUCCESS,
  start,
  schedule
});

const createNewScheduleFailure = () => ({
  type: types.CREATE_NEW_SCHEDULE_FAILURE
});

const publishScheduleRequest = scheduleId => ({
  type: types.PUBLISH_SCHEDULE_REQUEST,
  scheduleId
});

const publishScheduleSuccess = scheduleId => ({
  type: types.PUBLISH_SCHEDULE_SUCCESS,
  scheduleId
});

const publishScheduleFailure = () => ({
  type: types.PUBLISH_SCHEDULE_FAILURE
});

const unpublishScheduleRequest = scheduleId => ({
  type: types.UNPUBLISH_SCHEDULE_REQUEST,
  scheduleId
});

const unpublishScheduleSuccess = scheduleId => ({
  type: types.UNPUBLISH_SCHEDULE_SUCCESS,
  scheduleId
});

const unpublishScheduleFailure = () => ({
  type: types.UNPUBLISH_SCHEDULE_FAILURE
});

const saveScheduleRequest = (shifts, shiftsToRemove = [], scheduleId) => ({
  type: types.SAVE_SHIFTS_TO_SCHEDULE_REQUEST,
  shifts,
  shiftsToRemove,
  scheduleId
});

const saveScheduleSuccess = (shifts, scheduleId) => ({
  type: types.SAVE_SHIFTS_TO_SCHEDULE_SUCCESS,
  shifts,
  scheduleId
});

const saveScheduleFailure = () => ({
  type: types.SAVE_SHIFTS_TO_SCHEDULE_FAILURE

});

const saveShiftToWeekSchedule = (shift, scheduleId) => ({
  type: types.SAVE_SHIFT_TO_WEEK_SCHEDULE,
  shift,
  scheduleId
});

const removeShiftsFromSchedule = (shifts, scheduleId) => ({
  type: types.REMOVE_SHIFTS_FROM_SCHEDULE,
  shifts,
  scheduleId
});

const editExistingShift = (shift, scheduleId) => ({
  type: types.EDIT_EXISTING_SHIFT,
  shift,
  scheduleId
});

const copyExistingScheduleToNewWeekRequest = (scheduleId, start, end) => ({
  type: types.COPY_SCHEDULE_TO_NEW_WEEK_REQUEST,
  scheduleId,
  start,
  end
});

const copyExistingScheduleToNewWeekSuccess = (start, schedule) => ({
  type: types.COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS,
  start,
  schedule
});

const copyExistingScheduleToNewWeekFailure = (error) => ({
  type: types.COPY_SCHEDULE_TO_NEW_WEEK_FAILURE,
  error
});

const copyShiftToNewDatesRequest = (shift, dates) => ({
  type: types.COPY_SHIFT_TO_NEW_DATES_REQUEST,
  shift,
  dates
});

const copyShiftToNewDatesSuccess = () => ({
  type: types.COPY_SHIFT_TO_NEW_DATES_SUCCESS
});

const copyShiftToNewDatesFailure = () => ({
  type: types.COPY_SHIFT_TO_NEW_DATES_FAILURE
});

export default {
  getScheduleForWeekRequest,
  getScheduleForWeekSuccess,
  getScheduleForWeekFailure,
  createNewScheduleRequest,
  createNewScheduleSuccess,
  createNewScheduleFailure,
  publishScheduleRequest,
  publishScheduleSuccess,
  publishScheduleFailure,
  unpublishScheduleRequest,
  unpublishScheduleSuccess,
  unpublishScheduleFailure,
  setCurrentWeekScheduleId,
  saveScheduleRequest,
  saveScheduleSuccess,
  saveScheduleFailure,
  saveShiftToWeekSchedule,
  removeShiftsFromSchedule,
  editExistingShift,
  copyExistingScheduleToNewWeekRequest,
  copyExistingScheduleToNewWeekSuccess,
  copyExistingScheduleToNewWeekFailure,
  copyShiftToNewDatesRequest,
  copyShiftToNewDatesSuccess,
  copyShiftToNewDatesFailure
};
